import { render, staticRenderFns } from "./welcome-get-ready-for-training.vue?vue&type=template&id=5daf0ff2&scoped=true&"
import script from "./welcome-get-ready-for-training.vue?vue&type=script&lang=js&"
export * from "./welcome-get-ready-for-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf0ff2",
  null
  
)

export default component.exports